import { render, staticRenderFns } from "./DateCard.vue?vue&type=template&id=5654ed10&scoped=true"
import script from "./DateCard.vue?vue&type=script&lang=js"
export * from "./DateCard.vue?vue&type=script&lang=js"
import style0 from "./DateCard.vue?vue&type=style&index=0&id=5654ed10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5654ed10",
  null
  
)

export default component.exports